import { ReactNode } from "react";

type InvoiceFormSectionProps = {
  title?: ReactNode;
  children: ReactNode;
};

export const InvoiceFormSection = ({
  title,
  children,
}: InvoiceFormSectionProps) => (
  <div className="t-flex t-flex-col t-gap-4">
    {title && (
      <div className="t-text-subtitle-lg t-leading-6 t-text-text-60">
        {title}
      </div>
    )}
    {children}
  </div>
);
